import styled from 'styled-components';
import { StyledCategoriesList } from './CategoriesList/CategoriesList.style';
import { StyledSelectedCategory } from './SelectedCategory/SelectedCategory.style';
import { StyledWidgetHeader as CommonStyledWidgetHeader } from 'components/base/common-styles';

export const StyledWidgetHeader = styled(CommonStyledWidgetHeader)`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
`;

export const StyledCategoriesWidget = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  & ${StyledCategoriesList} {
    width: 49.7%;
  }
  & ${StyledSelectedCategory} {
    width: 49.7%;
  }
`;
